<template>
  <div
    class="spellchecker-alert"
    name="spellchecker"
    v-aha-click="onAlertClicked"
    v-tooltip="misspellFoundText"
  >
    <aha-icon-button :isActive="isSpellcheckerPanelActive" variant="tertiary">
      <aha-status-badge :dot="isDotVisible">
        <aha-icon
          name="spellchecker"
          width="20"
          height="20"
          viewBox="0 0 20 20"
        />
      </aha-status-badge>
    </aha-icon-button>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'

export default {
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
    }),
    ...mapGetters('spellchecker', ['misspells', 'isFetchingMisspells']),
    ...mapGetters('rightNav', ['isPanelActive', 'rightNavTabNames']),

    isSpellcheckerPanelActive() {
      return this.isPanelActive(this.rightNavTabNames.SPELL_CHECKER)
    },

    presentationId() {
      return this.presentation?.id
    },

    misspellCount() {
      return this.misspells?.length || 0
    },

    misspellCountInString() {
      return JSON.stringify(this.misspellCount)
    },

    misspellFoundText() {
      if (this.isFetchingMisspells) return this.$i18nPresenter.t('Potential Issues')
      return this.$i18nPresenter.tc('spellingIssues', this.misspellCount, { count: this.misspellCount })
    },

    isDotVisible() {
      return !this.isSpellcheckerPanelActive && this.misspellCount > 0
    },
  },

  async mounted() {
    await this.fetchMisspellListAction(this.presentationId)
  },

  destroyed() {
    this.resetMisspellsAction()

    if (this.isSpellcheckerPanelActive) {
      this.setRightNavActiveTabAction('')
    }
  },

  methods: {
    ...mapActions('spellchecker', ['fetchMisspellListAction', 'resetMisspellsAction']),
    ...mapActions('rightNav', ['setRightNavActiveTabAction']),

    async onAlertClicked() {
      if (this.isSpellcheckerPanelActive) {
        this.setRightNavActiveTabAction('')
      } else {
        this.setRightNavActiveTabAction(this.rightNavTabNames.SPELL_CHECKER)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.spellchecker-alert {
  @apply flex items-center cursor-pointer;
  &::v-deep {
    .aha-badge-2xs {
      @apply px-3 py-0.5 text-xs text-secondary-100 font-normal;
      @apply cursor-pointer;
    }
  }
  .alert-arrow {
    @apply transform rotate-90 ml-2;
  }
}
</style>
